package com.sddamico.util

fun formatPoints(points: Double): String {
    if (points == points.toLong().toDouble()) {
        return formatNumber(points.toLong())
    }
    return points.asDynamic().toLocaleString("en-US") as String
}

fun formatNumber(n: Long): String {
    return n.asDynamic().toLocaleString("en-US") as String
}

fun sportDisplayName(sport: String): String = when (sport) {
    "MENS_GOLF" -> "Golf"
    "MENS_TENNIS" -> "Men's Tennis"
    "WOMENS_TENNIS" -> "Women's Tennis"
    else -> sport
}

fun importanceLabel(importance: String): String = when (importance) {
    "MAJOR" -> "Major"
    "SPECIAL" -> "Special"
    else -> ""
}

private val MONTH_ABBREVS = arrayOf(
    "JAN", "FEB", "MAR", "APR", "MAY", "JUN",
    "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"
)

private val MONTH_NAMES = arrayOf(
    "JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE",
    "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"
)

/** Parse an ISO date string (yyyy-MM-dd) to a JS Date at midnight UTC */
fun parseLocalDate(iso: String): kotlin.js.Date {
    val parts = iso.split("-")
    return kotlin.js.Date(
        year = parts[0].toInt(),
        month = parts[1].toInt() - 1,
        day = parts[2].toInt()
    )
}

/** Days between two ISO date strings */
fun daysBetween(a: String, b: String): Int {
    val dateA = parseLocalDate(a)
    val dateB = parseLocalDate(b)
    val diffMs = dateB.getTime() - dateA.getTime()
    return (diffMs / (1000.0 * 60 * 60 * 24)).toInt()
}

/** "Scottie Scheffler" -> "S. Scheffler" */
fun abbreviateName(fullName: String): String {
    val parts = fullName.trim().split(" ")
    if (parts.size < 2) return fullName
    return "${parts.first().first()}. ${parts.last()}"
}

/** "2026-01-03" -> "JAN 3" */
fun formatScheduleDate(iso: String): String {
    val parts = iso.split("-")
    val month = parts[1].toInt() - 1
    val day = parts[2].toInt()
    return "${MONTH_ABBREVS[month]} $day"
}

/** Get the full month name for a month index (0-based) */
fun monthName(monthIndex: Int): String = MONTH_NAMES[monthIndex]

fun formatLastUpdated(isoDateTime: String): String {
    val date = kotlin.js.Date(isoDateTime)
    if (date.getTime().isNaN()) return isoDateTime
    val options = js("{month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit'}")
    return (date as Any).asDynamic().toLocaleString("en-US", options) as String
}

/** Format a UTC ISO datetime to Eastern time, e.g. "3:00p ET" */
fun formatMatchTime(isoUtc: String): String {
    val date = kotlin.js.Date(isoUtc)
    if (date.getTime().isNaN()) return ""
    val options = js("{timeZone: 'America/New_York', hour: 'numeric', minute: '2-digit'}")
    val timeStr = (date as Any).asDynamic().toLocaleString("en-US", options) as String
    return timeStr.replace(" AM", "a").replace(" PM", "p") + " ET"
}

/** Format a UTC ISO datetime to Eastern date, e.g. "Thu, Mar 27" */
fun formatMatchDate(isoUtc: String): String {
    val date = kotlin.js.Date(isoUtc)
    if (date.getTime().isNaN()) return ""
    val options = js("{timeZone: 'America/New_York', weekday: 'short', month: 'short', day: 'numeric'}")
    return (date as Any).asDynamic().toLocaleString("en-US", options) as String
}
